module.exports = __webpack_public_path__ + "static/media/aresBanner.c2d31410.jpg";